"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
var _1 = require(".");
var class_1 = require("../class");
var helpers_1 = require("../helpers");
var AnalyticsService = /** @class */ (function (_super) {
    __extends(AnalyticsService, _super);
    function AnalyticsService() {
        var _this = _super.call(this) || this;
        _this.sourceDatalayer = {};
        return _this;
    }
    AnalyticsService.prototype.updateSourceDataLayer = function (newSourceDataLayer) {
        if (newSourceDataLayer === void 0) { newSourceDataLayer = {}; }
        this.sourceDatalayer = __assign(__assign({}, this.sourceDatalayer), newSourceDataLayer);
    };
    AnalyticsService.prototype.clearSourceDataLayer = function () {
        this.sourceDatalayer = {};
    };
    AnalyticsService.prototype.collectImpressionData = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var collectedImressionData = {
            impression_element_campaign_id: [],
            impression_element_id: [],
            impression_element_position: [],
            impression_element_type: [],
        };
        if (helpers_1.EnvironmentHelper.isClientSide()) {
            var impressionData = document.getElementsByClassName("impressionData");
            for (var i = 0; i < impressionData.length; i++) {
                var target = impressionData.item(i);
                var impression_element_campaign_id = ((_b = (_a = target === null || target === void 0 ? void 0 : target.getElementsByClassName("impression_element_campaign_id")) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.innerText) || "";
                var impression_element_id = ((_d = (_c = target === null || target === void 0 ? void 0 : target.getElementsByClassName("impression_element_id")) === null || _c === void 0 ? void 0 : _c.item(0)) === null || _d === void 0 ? void 0 : _d.innerText) || "";
                var impression_element_position = ((_f = (_e = target === null || target === void 0 ? void 0 : target.getElementsByClassName("impression_element_position")) === null || _e === void 0 ? void 0 : _e.item(0)) === null || _f === void 0 ? void 0 : _f.innerText) || "";
                var impression_element_type = ((_h = (_g = target === null || target === void 0 ? void 0 : target.getElementsByClassName("impression_element_type")) === null || _g === void 0 ? void 0 : _g.item(0)) === null || _h === void 0 ? void 0 : _h.innerText) || "";
                collectedImressionData.impression_element_campaign_id.push(impression_element_campaign_id);
                collectedImressionData.impression_element_id.push(impression_element_id);
                collectedImressionData.impression_element_position.push(impression_element_position);
                collectedImressionData.impression_element_type.push(impression_element_type);
            }
        }
        return collectedImressionData;
    };
    AnalyticsService.prototype.collectInternalImpressionData = function () {
        var esito = {
            internal_element_campaign_id: undefined,
            internal_element_id: undefined,
            internal_element_position: undefined,
            internal_element_type: undefined,
        };
        if (helpers_1.EnvironmentHelper.isClientSide()) {
            var impressionInternalData = localStorage.getItem("internal");
            if (impressionInternalData) {
                localStorage.removeItem("internal");
                var parsedImpressionInternalData = JSON.parse(impressionInternalData);
                esito["internal_element_campaign_id"] =
                    (parsedImpressionInternalData === null || parsedImpressionInternalData === void 0 ? void 0 : parsedImpressionInternalData.internal_element_campaign_id) ||
                        undefined;
                esito["internal_element_id"] =
                    (parsedImpressionInternalData === null || parsedImpressionInternalData === void 0 ? void 0 : parsedImpressionInternalData.internal_element_id) || undefined;
                esito["internal_element_position"] =
                    (parsedImpressionInternalData === null || parsedImpressionInternalData === void 0 ? void 0 : parsedImpressionInternalData.internal_element_position) || undefined;
                esito["internal_element_type"] =
                    (parsedImpressionInternalData === null || parsedImpressionInternalData === void 0 ? void 0 : parsedImpressionInternalData.internal_element_type) || undefined;
            }
        }
        return esito;
    };
    AnalyticsService.prototype.triggerPageView = function (pageProps) {
        var routerService = _1.RouterService.getInstance();
        var analytics = helpers_1.AnalyticsHelper.getDataFromDataLayer();
        var _a = ("dataLayerGenericInfo" in pageProps &&
            pageProps.dataLayerGenericInfo) ||
            {}, _b = _a.pageName, pageName = _b === void 0 ? "" : _b, _c = _a.pageId, pageId = _c === void 0 ? "" : _c, _d = _a.issueDate, issueDate = _d === void 0 ? "" : _d, _e = _a.primaryCategory, primaryCategory = _e === void 0 ? "" : _e, _f = _a.subjectCategory, subjectCategory = _f === void 0 ? "" : _f, _g = _a.networkSource, networkSource = _g === void 0 ? "" : _g;
        var _h = ("properties" in pageProps && pageProps.properties) || {}, functionalCategory = _h.functional_category, siteAgencyArea = _h.site_agency_area, siteAgencyId = _h.site_agency_id;
        var _j = __assign(__assign(__assign(__assign({}, this.collectImpressionData()), this.collectInternalImpressionData()), this.utag_data), analytics), ext_page_url = _j.ext_page_url, impression_element_campaign_id = _j.impression_element_campaign_id, impression_element_id = _j.impression_element_id, impression_element_position = _j.impression_element_position, impression_element_type = _j.impression_element_type, internal_element_campaign_id = _j.internal_element_campaign_id, internal_element_id = _j.internal_element_id, internal_element_position = _j.internal_element_position, internal_element_type = _j.internal_element_type, site_agency_area = _j.site_agency_area, site_agency_id = _j.site_agency_id, tech_mediatorversion = _j.tech_mediatorversion, user_email = _j.user_email, user_username = _j.user_username, functional_category = _j.functional_category, issue_date = _j.issue_date, network_source = _j.network_source, page_company = _j.page_company, page_environment = _j.page_environment, page_id = _j.page_id, page_name = _j.page_name, primary_category = _j.primary_category, referring_url = _j.referring_url, subject_category = _j.subject_category;
        this.triggerView({
            ext_page_url: ext_page_url,
            impression_element_campaign_id: impression_element_campaign_id,
            impression_element_id: impression_element_id,
            impression_element_position: impression_element_position,
            impression_element_type: impression_element_type,
            internal_element_campaign_id: internal_element_campaign_id,
            internal_element_id: internal_element_id,
            internal_element_position: internal_element_position,
            internal_element_type: internal_element_type,
            site_agency_area: site_agency_area || siteAgencyArea,
            site_agency_id: site_agency_id || siteAgencyId,
            tech_mediatorversion: tech_mediatorversion,
            user_email: user_email,
            user_username: user_username,
            functional_category: functional_category || functionalCategory || "",
            issue_date: issue_date || issueDate,
            network_source: network_source || networkSource,
            page_company: page_company || "unipolsai",
            page_environment: page_environment || "prod",
            page_id: page_id || pageId,
            page_name: page_name || pageName,
            primary_category: primary_category || primaryCategory,
            referring_url: referring_url || routerService.getReferringUrl(),
            subject_category: subject_category || subjectCategory,
        });
    };
    AnalyticsService.prototype.triggerLink = function (analyticsToSend) {
        helpers_1.ConsoleHelper.log("[AnalyticsService - triggerLink]", analyticsToSend);
        if (this.utag) {
            this.utag.link(analyticsToSend);
        }
    };
    AnalyticsService.prototype.triggerView = function (analyticsToSend) {
        helpers_1.ConsoleHelper.log("[AnalyticsService - triggerView]", analyticsToSend);
        if (this.utag) {
            var filteredAnalytics = this.filterAnalytics(analyticsToSend);
            if (filteredAnalytics) {
                this.utag.view(filteredAnalytics);
            }
        }
    };
    AnalyticsService.prototype.filterAnalytics = function (analyticsToSend) {
        var response = analyticsToSend;
        var analyticsBlackList = [
            "home",
            "accesso",
            "preventivi",
            "tracking-sinistri",
            "telematica-mobilita",
            "denunce-inviate",
            "polizze",
            "polizza",
            "aggiorna-profilo",
            "aggiorna-profilo-esiti",
            "esito-aggiunta-carta",
            "registrazione-cliente",
            "reclamo prodotti",
            "pagamento",
            "agenzia",
            "esito",
            "pagamento-insoluto",
            "pagamento",
        ];
        if (analyticsToSend && analyticsToSend.page_name === "polizze") {
            var subject_category = analyticsToSend.subject_category, otherData = __rest(analyticsToSend, ["subject_category"]);
            response = otherData;
        }
        else if (analyticsToSend && analyticsToSend.page_name === "polizza") {
            var tech_mediatorversion = analyticsToSend.tech_mediatorversion, otherData = __rest(analyticsToSend, ["tech_mediatorversion"]);
            response = otherData;
        }
        if (analyticsToSend &&
            analyticsBlackList.includes(analyticsToSend.page_name)) {
            response = undefined;
        }
        //Rimuoviamo dal referring url tutti i riferimenti ad email esterne nel referring-url
        if (analyticsToSend && analyticsToSend.referring_url) {
            var referringUrlValue = analyticsToSend.referring_url;
            var splittedValues = referringUrlValue.split("?");
            if (splittedValues.length > 0)
                analyticsToSend.referring_url = splittedValues[0];
        }
        return response;
    };
    Object.defineProperty(AnalyticsService.prototype, "utag", {
        get: function () {
            var utagInstance = null;
            if (helpers_1.EnvironmentHelper.isClientSide()) {
                if ("utag" in window) {
                    utagInstance = window["utag"];
                }
                else {
                    helpers_1.ConsoleHelper.error("utag is not available");
                }
            }
            return utagInstance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnalyticsService.prototype, "utag_data", {
        get: function () {
            var utagDataInstance = {};
            if (helpers_1.EnvironmentHelper.isClientSide()) {
                if ("utag_data" in window) {
                    utagDataInstance = window["utag_data"];
                }
                else {
                    helpers_1.ConsoleHelper.error("utag_data is not available");
                }
            }
            return utagDataInstance;
        },
        enumerable: false,
        configurable: true
    });
    AnalyticsService.className = "AnalyticsService";
    return AnalyticsService;
}(class_1.Singleton));
exports.AnalyticsService = AnalyticsService;
